import React from 'react';
import {Badge, Col, Row} from 'react-bootstrap';

import {Field, FieldArray} from 'formik';

import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import {DIAS_SEMANA, ErrorMessage, PERIODO, TIPO_EVENTO} from '../../../_helpers';

import SelectSearch from 'react-select-search';

export const Paso3 = ({values, state, setFieldValue, optionsSensores}) => (
    <>
        <Row>
            <Col xs={12}>
                <h5><Badge className=" text-white">Paso<b>2</b></Badge></h5>
            </Col>

            {values.tipoEvento.id === TIPO_EVENTO.AUTOMATICO &&
                <>
                    <Col xs={12}>
                        <b>¿Qué condicion debe cumplirse para activar al evento?</b>
                    </Col>
                    <Col xs={12} className="mb-4">
                        Mensaje explicativo personalizado segun el tipo de sensor.
                    </Col>
                    <Col xs={12}>
                        <ErrorMessage name={`sensor.id`}/>
                        <SelectSearch onChange={(selectedOption) => setFieldValue(`sensor.id`, selectedOption)}
                                      options={optionsSensores} name={`sensor.id`}
                                      value={'' + values.sensor.id}
                                      search={true}
                                      placeholder="Seleccione un sensor"/>

                    </Col>

                    <Col className="mt-4" xs={8} lg={6}>
                        <label>Condición</label><ErrorMessage name={`condicion.id`}/>
                        <Field value={values.condicion.id} component="select" name={`condicion.id`}>
                            <option value=''>Seleccione</option>
                            {state.condiciones && state.condiciones.map(ts =>
                                <option key={ts.id} value={ts.id}>{ts.descripcion}</option>
                            )}
                        </Field>

                    </Col>
                    <Col xs={4} lg={6} className="mt-4">
                        <label htmlFor="valor">Valor</label><ErrorMessage name={`valor`}/>
                        <Field name="valor"/>

                    </Col>
                </>
            }
            {values.tipoEvento.id === TIPO_EVENTO.PROGRAMADO &&
                <>
                    <Col xs={12}>
                        <b>¿Que dia y horarios desea ejecutar el evento?</b>
                    </Col>
                    <Col xs={12} className="mb-4">
                        Mensaje explicativo personalizado segun el tipo de evento.
                    </Col>
                    <Col xs={8} lg={6}>
                        <label>Periodo</label><ErrorMessage name={`periodo.id`}/>
                        <Field value={values.periodo ? values.periodo.id : ''} component="select" name={`periodo.id`}>
                            <option value=''>Seleccione</option>
                            {state.periodos && state.periodos.map(ts =>
                                <option key={ts.id} value={ts.id}>{ts.descripcion}</option>
                            )}
                        </Field>

                    </Col>

                    {values.periodo.id == PERIODO.SEMANAL ?

                        <Col xs={12} lg={12}>

                            <label htmlFor="diaSemana">Dia de la semana</label><ErrorMessage name={`diaSemana`}/>
                            <FieldArray
                                name="diaSemana"
                                render={arrayHelpers => (
                                    <div className="mt-4 mb-4">
                                        {DIAS_SEMANA.map((dia, index) =>
                                            <div key={dia.id}>
                                                <input
                                                    className="option-input checkbox"
                                                    name="sensor"
                                                    type="checkbox"
                                                    value={dia.id}
                                                    checked={values.diaSemana.some(se => se === dia.id)}
                                                    onChange={e => {
                                                        console.log(e)
                                                        if (e.target.checked) {
                                                            arrayHelpers.push(dia.id);
                                                        } else {
                                                            const idx = values.diaSemana.findIndex(se => se === dia.id);

                                                            arrayHelpers.remove(idx);
                                                        }
                                                    }}
                                                />
                                                <label className="label-check">{dia.descripcion}</label>
                                            </div>
                                        )}
                                    </div>
                                )}
                            />

                        </Col>
                        : null}

                    <Col xs={4} lg={6}>

                        <label htmlFor="hora">Horario</label>
                        <div>
                            <DateTimePicker
                                defaultValue={new Date(2020, 6, 6, values.hora, values.minuto, 0, 0)}
                                culture="en-GB"
                                format="HH:mm"
                                timeFormat="HH:mm"
                                dateFormat="HH:mm"
                                onChange={value => {
                                    value.getMinutes() ? setFieldValue("minuto", value.getMinutes()) : setFieldValue("minuto", 0)
                                    value.getHours() ? setFieldValue("hora", value.getHours()) : setFieldValue("hora", 0)
                                }}
                                time={true}
                                date={false}
                            />
                        </div>

                    </Col>
                </>
            }
        </Row>
    </>
);
